export var selectSceneInfo = function (state) { return state.scenes; };
export var selectAreSceneDependenciesLoaded = function (state, scene) {
    var dependencies = scene.assetBundleDependencies;
    return (dependencies == undefined ||
        dependencies.every(function (bundleId) {
            var bundleInfo = state.loading.bundles[bundleId];
            return bundleInfo != undefined && bundleInfo.isLoaded;
        }));
};



//////////////////
// WEBPACK FOOTER
// ./src/selectors/selectSceneInfo.ts
// module id = 2130
// module chunks = 3